import React, { useState } from 'react';
import { Progress } from 'tea-component';
import './index.scss';

export default function ProgressBox(props: any) {
  const { data } = props;

  return (
    <div className="dbi-market-progressbox" style={{ width: data?.num, minWidth:45 }}>
      <div className="progressbox-text">{data?.text}</div>
      <Progress
        className="progressbox-line"
        percent={data?.percent ? data?.percent : 100}
        strokeColor={data?.color}
      />
      <div className="progressbox-num">{data?.num}</div>
    </div>
  );
}
